import React from "react";
import { useSingleChargePoint } from "../../../hooks/useChargePoint";
import { ChargePoint } from "../../../types/stations.types";
import useNavigationApp from "../../../../../navigation/useNavigationApp";
import { limitString } from "../../../../../utils/string.utils";

export interface ChargePointInfoProps {
  idChargePoint?: string;
  idStation?: string;
  info: keyof ChargePoint;
  emptyText?: string;
  styled?: boolean;
  renderComponent?: (config: {
    labelRender: React.ReactNode;
    value: string | undefined;
    goTo: () => void;
  }) => JSX.Element;
  limitText?: number;
}

export default function SingleChargePointInfo({ idChargePoint, idStation, emptyText, renderComponent, info, limitText}: ChargePointInfoProps) {
  const { singleChargePointQuery } = useSingleChargePoint({
    chargePointId: idChargePoint,
    stationId: idStation,
  });

  const navigateApp = useNavigationApp();
  if(renderComponent) {
    return renderComponent({
      labelRender: <>{singleChargePointQuery.data?.charge_point_name}</>,
        value: singleChargePointQuery.data?.charge_point_name,
      goTo: () => {
        navigateApp.goToSingleChargePoint(idStation, idChargePoint);
      },
    });
  }

  if (singleChargePointQuery.isLoading) {
    return <>...</>;
  }
  if (singleChargePointQuery.isError) {
    return <>{emptyText}</>;
  }

  if (!singleChargePointQuery.data){
    return <>{emptyText}</>;
  }

  const value = limitString(singleChargePointQuery.data[info],limitText );

  return <>{value}</>;
}
